/**
 * localStorage keys for persisting list/search query strings per TAP nav route.
 */

export function getNavSearchStorageKey(path) {
  return `searchParams:${path}`;
}

/**
 * Builds the URL (pathname + search) for a nav target, including any saved
 * query string for that route.
 *
 * @param {string} path - Route pathname (e.g. "/home")
 * @returns {string}
 */
export function buildNavTo(path) {
  const saved =
    typeof localStorage !== "undefined"
      ? localStorage.getItem(getNavSearchStorageKey(path)) || ""
      : "";
  return `${path}${saved}`;
}

/**
 * Persists the current page's search params and records the destination panel
 * before following a nav link (same-tab or new tab).
 *
 * @param {string} fromPathname - Current location.pathname
 * @param {string} fromSearch - Current location.search
 * @param {string} toPath - Destination pathname only (no query)
 */
export function persistBeforeNavTo(fromPathname, fromSearch, toPath) {
  localStorage.setItem(getNavSearchStorageKey(fromPathname), fromSearch);
  localStorage.setItem("activePanel", toPath);
}
